import React from 'react';
import PropTypes from 'prop-types';

import AgeValidationModal from '../AgeValidationModal';
import AgeValidationModalIsOfAge from '../AgeValidationModalIsOfAge';

import { AGE_VALIDATION_TYPE } from '../../constants';

function AgeValidationModalContainer({
  onAccept,
  onClose,
  open,
  type,
  message,
}) {
  return (
    <>
      {type === AGE_VALIDATION_TYPE.DATE_OF_BIRTH ? (
        <AgeValidationModal
          open={open}
          onAccept={onAccept}
          onClose={onClose}
          message={message}
        />
      ) : (
        <AgeValidationModalIsOfAge
          open={open}
          onAccept={onAccept}
          onClose={onClose}
          message={message}
        />
      )}
    </>
  );
}

AgeValidationModalContainer.propTypes = {
  onAccept: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  type: PropTypes.string,
  message: PropTypes.string,
};

export default AgeValidationModalContainer;
